import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WarehouseDetailPage } from '@/features/data/warehouses/warehouse-detail-page';
import { isWarehouseTab, type WarehouseTab } from '@/features/data/warehouses/warehouse-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** L'onglet actif vit dans l'URL (`?tab=tables`) : une capture ou un lien pointe sur un onglet précis. */
export const Route = createFileRoute('/$tenant/sql/$warehouseId/')({
  validateSearch: (search: Record<string, unknown>): { tab: WarehouseTab } => ({
    tab: isWarehouseTab(search['tab']) ? search['tab'] : 'summary',
  }),
  component: WarehouseRoute,
});

function WarehouseRoute() {
  const { tenant, warehouseId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="sql"
      crumbs={[{ label: t('nav.items.sql') }, { label: warehouseId, mono: true }]}
    >
      <WarehouseDetailPage
        tenantId={tenant}
        warehouseId={warehouseId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
